import { render, staticRenderFns } from "./AdminCustomerProfileEdit.vue?vue&type=template&id=99bfb6e2&scoped=true"
import script from "./AdminCustomerProfileEdit.vue?vue&type=script&lang=js"
export * from "./AdminCustomerProfileEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminCustomerProfileEdit.vue?vue&type=style&index=0&id=99bfb6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bfb6e2",
  null
  
)

export default component.exports